@if (isBannerVisible) {
  <sd-info-banner
    [brand]="brand"
    [isVisible]="isBannerVisible"
    textKey="product.brandcorner.banner.text"
    [data]="bannerData"
    (isVisibleChange)="bannerVisibilityChange()"
  />
}

@if (isLoading || overview) {
  <sd-product-overview
    [isSSR]="false"
    [showSkeeper]="showSkeeper"
    [objSkeeper]="objSkeeper"
    [isLoading]="isLoading"
    [overview]="overview"
    [titleLevel]="1"
    [images]="images"
    [isBundle]="true"
    (changeStore)="isStoreModalOpened = true"
    (cart)="addToCart($event)"
    (notify)="notifyMe()"
    (productSellerModal)="openSellerModal()"
    [klarnaData]="klarnaData"
    (dividedClick)="dividedClick()"
    [brand]="brand"
    pageTemplate="Bundle"
  >
    @if (displayPaypalBanner) {
      <wc-paypal-banner
        [price]="price"
        [position]="POSITION"
        [messageLanguage]="activeLanguage"
        sd-additional-elements
      />
    }
    @if (hasVideos) {
      <wc-skeeper-shoppable-content
        sd-shoppable-content
        [data]="skeeperShoppableContentData"
        (hasVideos)="checkHasVideo($event)"
      />
    }
    <div sections>
      <ng-content select="[pdp-sections]" />
    </div>
  </sd-product-overview>
}

@if (!!currentBundle) {
  @defer (when isStoreModalOpened) {
    <sd-modal-default
      [(isOpened)]="isStoreModalOpened"
      [modalTitle]="'storelocator.changeStoreModalTitle' | translate"
      [modalTitleLevel]="4"
      [noPadding]="true"
      >
      @if (isStoreModalOpened) {
        <wc-store-locator />
      }
    </sd-modal-default>
  }

  <sd-product-seller-modal [(isOpened)]="isOpenedSellerModal" />

  <wc-product-notification-modal
    [productCode]="currentBundle.id"
    [productName]="currentBundle.name"
    [(notifyModalOpened)]="notifyModalOpened"
  />

  <wc-oney-modal [(isOpenedOneyModal)]="isOpenedOneyModal" [bundleId]="currentBundle.id" />
}
